import React from "react";
import "./Hero.css";

const Hero = ({ t, language }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-image">
          <div className="profile-photo">
            <img
              src={process.env.PUBLIC_URL + "/img/profile.jpg"}
              alt="Alireza Adibi"
              className="profile-img"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
            <div className="photo-placeholder" style={{ display: "none" }}>
              <span>AA</span>
            </div>
          </div>
        </div>
        <div className="hero-content">
          <div className="hero-name-wrapper">
            <img
              src={process.env.PUBLIC_URL + "/img/android-chrome-192x192.png"}
              alt="Alireza Adibi Logo"
              className="hero-logo"
            />
            <h1 className="hero-name">
              <span aria-hidden="true">
                {language === "fa" ? "علیرضا ادیبی" : "Alireza Adibi"}
              </span>
              <span className="sr-only">
                {language === "fa"
                  ? "علیرضا ادیبی | توسعه‌دهنده هوش مصنوعی و دانشجوی علوم کامپیوتر"
                  : "Alireza Adibi | AI Developer & Computer Science Student"}
              </span>
            </h1>
          </div>
          <h2 className="hero-title">{t.hero.title}</h2>
          <p className="hero-bio">{t.hero.bio}</p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => window.print()}>
              {t.hero.downloadResume}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => scrollToSection("contact")}
            >
              {t.hero.contactMe}
            </button>
          </div>
          <div className="social-icons">
            <a
              href="https://github.com/alirezaadibi2006"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
              </svg>
            </a>
            <a
              href="https://t.me/AI_DailyPlus"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 240 240"
                fill="currentColor"
              >
                <path d="M120 0C53.7 0 0 53.7 0 120s53.7 120 120 120 120-53.7 120-120S186.3 0 120 0zm58.7 78.9l-21 98.6c-1.6 6.8-5.8 8.5-11.7 5.3l-32.5-23.9-15.7 15.1c-1.7 1.7-3.1 3.1-6.3 3.1l2.3-32.5 59.2-53.4c2.6-2.3-0.6-3.6-4-1.3l-73.1 46.1-31.5-9.8c-6.8-2.1-6.9-6.8 1.4-10.1l121.2-46.7c5.6-2.1 10.5 1.3 8.2 9.9z" />
              </svg>
            </a>

            <a
              href="https://linkedin.com/in/alireza-adibi"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
            <a href="mailto:alireza.adibi.2006@gmail.com" aria-label="Email">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
